import 'bootstrap-icons/font/bootstrap-icons.css';
import 'remixicon/fonts/remixicon.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';

import './App.css';
import { useEffect, useState } from 'react';
import {
  Routes,
  Route,
  Navigate,
  useNavigate,
  useLocation,
} from 'react-router-dom';

import HomePage from './pages/HomePage';
import LoginPage from './pages/loginPage/LoginPage';
import Page404 from './pages/errorPage/Page404';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(null);
  const navigate = useNavigate();
  const location = useLocation(); // Ambil lokasi saat ini

  useEffect(() => {
    const token = localStorage.getItem('access_token');
    if (token) {
      setIsLoggedIn(true);
    } else {
      setIsLoggedIn(false);
    }
  }, []);

  const handleLogin = (status) => {
    setIsLoggedIn(status);
    if (status) {
      navigate('/'); // Jika login berhasil, tetap di root "/"
    } else {
      navigate('/login'); // Jika logout, pindah ke "/login"
    }
  };

  // Jika isLoggedIn masih null, tampilkan loading untuk menghindari navigasi awal yang salah
  if (isLoggedIn === null) {
    return <div>Loading...</div>;
  }

  return (
    <Routes>
      {/* Route Login */}
      <Route
        path="/login"
        element={
          !isLoggedIn ? (
            <LoginPage onLogin={handleLogin} />
          ) : (
            <Navigate to={location.pathname} replace /> // Tetap di halaman yang sama setelah login
          )
        }
      />

      {/* Jika sudah login, akses semua halaman dari "/" */}
      <Route
        path="/*"
        element={
          isLoggedIn ? (
            <HomePage onLogout={handleLogin} />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />

      {/* Redirect halaman yang tidak ditemukan ke 404 */}
      <Route path="*" element={<Page404 />} />
    </Routes>
  );
}

export default App;
